

<template>
  <div class="challenge-container">
    <div class="outbox" v-if="!complete">
      <div class="challenge-header">
        <div class="title">{{ challengeData.tasp_title }}</div>
        <div class="introduction" v-html="challengeData.tasp_content"></div>
      </div>
    
      <!-- 表单 -->
      <el-form 
        ref="form" 
        :model="formData" 
        :rules="rules" 
        label-position="top"
        class="apply-form">

        <el-form-item 
          :label="$t('机会点名称')" 
          prop="title">
          <el-input 
            maxlength="100"
            v-model="formData.title" 
            :placeholder="$t('请填写机会点名称')">
          </el-input>
        </el-form-item>

        <el-form-item 
          :label="$t('机会点编码')" 
          prop="code">
          <el-input 
            maxlength="50"
            size="small"
            v-model="formData.code" 
            :placeholder="$t('请填写机会点编码')">
          </el-input>
        </el-form-item>

        <el-form-item 
          :label="$t('下单设备型号')" 
          prop="devicecode">
          <el-input 
            maxlength="50"
            size="small"
            v-model="formData.devicecode" 
            :placeholder="$t('请填写下单设备型号')">
          </el-input>
        </el-form-item>

        <el-form-item 
          :label="$t('金额')" 
          prop="price">
          <el-input 
            size="small"
            type="number"
            maxlength="15"
            :min="0"
            :max="999999999"
            @input="handlePriceChange"
            v-model="formData.price" 
            :placeholder="$t('请填写金额')">
          </el-input>
        </el-form-item>

        <el-form-item 
          :label="$t('项目描述')" 
          prop="desc">
          <el-input 
            type="textarea" 
            v-model="formData.desc" 
            :rows="5"
            :maxlength="200"
            show-word-limit
            :placeholder="$t('请填写项目描述')">
          </el-input> 
        </el-form-item>

        <el-form-item
          :label="$t('项目下单截图')"
          prop="images">
          
          <Uploadimg v-model="formData.images" :fileLimit="9" upType="IMGARR" :isUseOss="true" />
        </el-form-item>


      </el-form>
      
      <div class="action-bar">
        <el-button type="text" class="submit-btn" v-throttle="2000" @click="submitForm">{{ $t('提交') }}</el-button>
      </div>
    </div>
    
    <Result v-if="complete" :typeNum="7" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id" :continueAction="continueAction"></Result>

  </div>
</template>
 
<script>
import Uploadimg from "@/components/Uploadimg/challenge";
import Editor from "../../components/Editor/index.vue";
import Result from './components/result.vue';
import { taskDetailList,taskSubmit } from '@/api/challenge';

export default {
  name: 'projectorder',
  components: {
    Result,
    Editor,
    Uploadimg
  },
  data() {
    return {
      complete: false,
      challengeData: {
        tasp_title: '',
        tasp_describe: '',
      },
      init: {},
      options: [],
      formData: {
        title: '',
        code: '',
        devicecode: '',
        price: '',
        desc: '',
        images: '',
      },
      rules: {
        title: [
          { required: true, message: this.$t('请填写机会点名称'), trigger: 'blur', validator: (rule, value, callback) => {
              if(/^[\s]*$/.test(value)){
                callback(new Error(this.$t('请填写机会点名称')));
              }else{
                callback();
              }
            }
          }
        ],
        devicecode: [
          { required: true, message: this.$t('请填写下单设备型号'), trigger: 'blur', validator: (rule, value, callback) => {
              if(/^[\s]*$/.test(value)){
                callback(new Error(this.$t('请填写下单设备型号')));
              }else{
                callback();
              }
            }
          }
        ],
        code: [
          { required: true, message: this.$t('请填写机会点编码'), trigger: 'blur', validator: (rule, value, callback) => {
              if(/^[\s]*$/.test(value)){
                callback(new Error(this.$t('请填写机会点编码')));
              }else{
                callback();
              }
            }
          }
        ],
        images: [
          { required: true, message: this.$t('请上传项目下单截图'), trigger: 'blur' }
        ],
      }
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id; // 获取路由参数 活动id
    },
    tas_id() {
      return this.$route.params.tas_id; // 获取路由参数 阶段id
    },
    tasp_id() {
      return this.$route.params.tasp_id; // 获取路由参数 试卷id
    },
  },
	mounted(){
    this.getData();
	},
  methods: {
    async getData(){
      const res = await taskDetailList({ 
        ta_id: this.ta_id,//358
        tas_id: this.tas_id,//1
        tasp_id: this.tasp_id //25
       });
      if(res.status == 200){
        if(res.data.status == false){
          this.$message.error(res.data.msg);
          return;
        }
        this.challengeData = res.data.paper;
      }
    },
    handlePriceChange(e) {
      // 如果为空，直接返回空字符串
      if (e === '') {
        this.formData.price = '';
        return;
      }
      
      // 确保输入值不小于0
      let value = parseFloat(e);
      if (value < 0) {
        value = 0;
      }
      if(value > 999999999){
        value = 999999999;
      }
      
      // 如果输入包含小数点
      if (e.toString().includes('.')) {
        // 获取小数部分
        let decimalPart = e.toString().split('.')[1];
        // 如果小数部分超过2位，则截取为2位
        if (decimalPart && decimalPart.length > 2) {
          // 限制最多两位小数
          this.formData.price = value.toFixed(2);
        } else {
          // 保持原样
          this.formData.price = e;
        }
      } else {
        // 整数直接显示
        this.formData.price = value.toString();
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 表单验证通过，可以提交数据
          let subObj = {
            ta_id: this.challengeData.ta_id,
            tas_id: this.challengeData.tas_id,
            tasp_id: this.challengeData.tasp_id,
            dd_question_type: this.challengeData.dd_question_type,
            data: this.formData
          }
          this.submitData(subObj);
        } else {
          // this.$message.error('请检查表单内容！');
          return false;
        }
      });
    },
    async submitData(subObj){
      const loading = this.$loading({
        lock: false,
        text: this.$t('加载中'),
        background: 'rgba(0, 0, 0, 0.1)'
      });
      const res = await taskSubmit(subObj);
      loading.close();
      if(res.status == 200){
          this.complete = true;
          this.formData = {
            title: '',
            code: '',
            devicecode: '',
            price: '',
            desc: '',
            images: '',
          };
          window.scrollTo({ top: 0, behavior: 'smooth' });
        this.$message.success(this.$t('提交成功'));
      }else{
        // this.$message.error(this.$t('提交失败'));
      }
    },
    continueAction(){
      this.complete = false;
      this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
.outbox{
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px 32px 0;
	&:last-child{
		margin-bottom: 0;
	}
}
.challenge-container {
  width: 100%;
  padding: 80px 120px 20px;
  background: #f9f9f9;
  min-height: 100vh;
  color: #191919;
  .challenge-header {
    margin-bottom: 32px;
    .title {
      font-size: 26px;
			line-height: 30px;
      margin-bottom: 16px;
    }    
    .introduction {
      font-size: 14px;
      line-height: 24px;
			font-weight: 300;
      color: #595959;
    }
  }
  
  .section-title {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 14px;
  }


  .action-bar {
    text-align: center;
    padding: 24px 0 32px;
    border-top: 1px dashed rgb(230, 230, 230);
    .submit-btn {
			box-sizing: border-box;
      font-size: 14px;
			border: 1px solid rgb(179, 0, 0);
			border-radius: 20px;
			width: 86px;
			background: rgb(255, 255, 255);
      color: #B30000;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background-color: rgba(179, 0, 0, 0.1);
      }
    }
  }
}

.apply-form {
  width: 100%;
  
  ::v-deep .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      padding: 0;
      line-height: 22px;
      margin-bottom: 8px;
      color: #191919;
    }
    
    .el-form-item__content {
      line-height: normal;
    }
    
    .el-input {
      width: 100%;
      
      .el-input__inner {
        width: 100%;
        height: 36px;
        line-height: 36px;
      }
      &.el-input--small {
        .el-input__inner {
          width: 60%;
          height: 32px;
          line-height: 32px;
        }
      }
    }
    .el-form-item_tip{
      color: #777777;
      font-size: 12px;
      line-height: 18px;
      margin-top: 4px;
    }
    .el-textarea {
      width: 100%;
      
      .el-textarea__inner {
        width: 100%;
        line-height: 22px;
      }
      
      .el-input__count {
        right: 10px;
        bottom: 2px;
        font-size: 12px;
        color: #808080;
        background: transparent;
        line-height: 20px;
        height: 20px;
      }
    }
    .upload-demo{
      width: 100%;
      .el-upload-dragger{
        width: 100%;
        height: 150px;
        .el-icon-picture{
          font-size: 36px;
          color: #8abef3;
          margin: 32px 0 16px;
          line-height: 40px;
        }
      }
      .el-upload{
        width: 100%;
      }
      .el-upload__tip{
        color: #808080;
      }
      .el-upload__text{
        width: 100%;
        &.text2{
          color: #808080;
          font-size: 12px;
        }
        em{
          color: #0067D1;
        }
      }
    }
    .tox .tox-toolbar{
      background-color: #fff;
    }

  }
}
</style>